<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row project-list">
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1">
                      <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                        <button type="button" class="btn btn-outline-primary btn1">{{selectedTechnology}}</button>
                        <button type="button" class="btn btn-outline-primary dropdown-toggle" ngbDropdownToggle
                          aria-haspopup="true" aria-expanded="false">
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu" role="menu">
                          <button class="dropdown-item" *ngFor="let item of technology_List" (click)="getTechnologyId(item?._id,item?.displayname)">{{item.displayname}}</button>
                        </div>
                      </div>
                    </div>


                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref" autocomplete="off"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" (keydown.enter)="getFilterProject($event.target.value)" #name />
                      <button class="btn search-btn glow position-absolute" (click)="getFilterProject(name.value)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <!-- <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/jobs/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div> -->
                  </div>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Job Audit Guideline</button>
                  </div>
                <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name />
                      <button class="btn search-btn glow position-absolute" (click)="getFilterProject(name.value)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/jobs/add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>

                  </div>
                </div> -->
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column name="Project Name" prop="name" [width]="350">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <img class="rounded-circle mr-1" *ngIf="row.image" [src]="imageUrl + row.image" height="32"
                      width="32" />
                    <!-- <img class="rounded-circle mr-1" *ngIf="!row.image" src="assets/MeanderLIVE-icon.png" height="32"
                      width="32" /> -->
                    <!-- <div class="cell-line-height">
                      <a
                        class="line-height-1 mb-0"
                        [routerLink]="['/project/project-view', row._id]"
                        (click)="editProject(row._id)"
                        >{{ row?.Pname }}</a
                      >
                    </div> -->
                    <div class="cell-line-height cursor-pointer" [routerLink]="['/project/project-view', row._id]"
                      (click)="editProject(row._id)">
                      <p class="font-medium-1 line-height-1 mb-0" [ngClass]="{'bg-light-danger': row?.isalert == 'yes'}">
                        {{ row.name }}
                      </p>
                      <span class="text-muted font-small-2" [ngClass]="{'bg-light-success':row?.priority[0]?.name == 'normal' , 'bg-light-danger':row?.priority[0]?.name == 'urgent' , 'bg-light-warn':row?.priority[0]?.name == 'high'}">
                        {{ row?.priority[0]?.displayname}}</span>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <!-- <ngx-datatable-column name="Project Budget" prop="projectbudget" [width]="150"></ngx-datatable-column> -->
              <ngx-datatable-column name="Productivity" [width]="170">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span>
                   
                    <span placement="right" ngbTooltip="Sprint">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.sprints?.alert =='yes','avatar-border':row?.sprints?.name !==''|| row?.sprints?.lastaudit !==''}" (click)="openModal(myModal,row,'Sprint','sprints',row?.sprints.name,row?.sprints?.alert,row?.sprints?.lastaudit)">
                        <div class="avatar-content">S</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'Sprint','sprints',row?.sprints)">{{row?.sprints}}</p> -->
                    </span>
                    <span placement="right" ngbTooltip="MoM">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.mom?.alert =='yes','avatar-border':row?.mom?.name !==''|| row?.mom?.lastaudit !==''}" (click)="openModal(myModal,row,'MOM','mom',row?.mom.name,row?.mom?.alert,row?.mom?.lastaudit)">
                        <div class="avatar-content">M</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'MOM','mom',row?.mom)">{{row?.mom}}</p> -->
                    </span>
                    <span placement="right" ngbTooltip="BitBucket">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.bitbucket?.alert =='yes','avatar-border':row?.bitbucket?.name !==''|| row?.bitbucket?.lastaudit !==''}"  (click)="openModal(myModal,row,'BitBucket','bitbucket',row?.bitbucket.name,row?.bitbucket?.alert,row?.bitbucket?.lastaudit)">
                        <div class="avatar-content">B</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'BitBucket','bitbucket',row?.bitbucket)">{{row?.bitbucket}}</p> -->
                    </span>
                    <span placement="right" ngbTooltip="KPI">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.kpi?.alert =='yes','avatar-border':row?.kpi?.name !==''|| row?.kpi?.lastaudit !==''}" (click)="openModal(myModal,row,'KPI','kpi',row?.kpi.name,row?.kpi?.alert,row?.kpi?.lastaudit)">
                        <div class="avatar-content">K</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'KPI','kpi',row?.kpi)">{{row?.kpi}}</p> -->
                    </span>
                  </span>

                </ng-template>

              </ngx-datatable-column>
           


              <!-- <ngx-datatable-column name="Communication" prop="Communication" [width]="170">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'Communication','Communication',row?.Communication)">{{row?.Communication}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Sprint" prop="sprints" [width]="120">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'Sprint','sprints',row?.sprints)">{{row?.sprints}}</p>
                </ng-template>
              </ngx-datatable-column> -->
              <!-- <ngx-datatable-column name="MOM" prop="mom" [width]="120">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'MOM','mom',row?.mom)">{{row?.mom}}</p>
                </ng-template>
              </ngx-datatable-column> -->
              <ngx-datatable-column name="Conversation" [width]="170">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span>
                    <span placement="right" ngbTooltip="Communication">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.Communication?.alert =='yes','avatar-border':row?.Communication?.name !==''|| row?.Communication?.lastaudit !==''}" (click)="openModal(myModal,row,'Communication','Communication',row?.Communication.name,row?.Communication?.alert,row?.Communication?.lastaudit)">
                        <div class="avatar-content">C</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'Communication','Communication',row?.Communication)">{{row?.Communication}}</p>  -->
                    </span>
                    <span placement="right" ngbTooltip="Reports">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.reports?.alert =='yes','avatar-border':row?.reports?.name !==''|| row?.reports?.lastaudit !==''}" (click)="openModal(myModal,row,'Reports','reports',row?.reports.name,row?.reports?.alert,row?.reports?.lastaudit)">
                        <div class="avatar-content">R</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'Reports','reports',row?.reports)">{{row?.reports}}</p> -->
                    </span>
                    <span placement="right" ngbTooltip="Work Dairy"> 
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.workdairy?.alert =='yes','avatar-border':row?.workdairy?.name !==''|| row?.workdairy?.lastaudit !==''}"  (click)="openModal(myModal,row,'Work Dairy','workdairy',row?.workdairy.name,row?.workdairy?.alert,row?.workdairy?.lastaudit)">
                        <div class="avatar-content">W</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'Work Dairy','workdairy',row?.workdairy)">{{row?.workdairy}}</p> -->
                    </span>
                    <span placement="right" ngbTooltip="Demo">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.demo?.alert =='yes','avatar-border':row?.demo?.name !==''|| row?.demo?.lastaudit !==''}"  (click)="openModal(myModal,row,'Demo','demo',row?.demo.name,row?.demo?.alert,row?.demo?.lastaudit)">
                        <div class="avatar-content">D</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'Demo','demo',row?.demo)">{{row?.demo}}</p> -->
                    </span>
                 
                   
                    
                  </span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Documentation" [width]="170">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <span>
                    <span placement="right" ngbTooltip="FRS/DMS">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.dmsfrs?.alert =='yes','avatar-border':row?.dmsfrs?.name !==''|| row?.dmsfrs?.lastaudit !==''}" (click)="openModal(myModal,row,'FRS/DMS','dmsfrs',row?.dmsfrs.name,row?.dmsfrs?.alert,row?.dmsfrs?.lastaudit)">
                        <div class="avatar-content">F</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'FRS/DMS','dmsfrs',row?.dmsfrs)">{{row?.dmsfrs}}</p> -->
                    </span>
                    <span  placement="right" ngbTooltip="QA">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.qa?.alert =='yes','avatar-border':row?.qa?.name !==''|| row?.qa?.lastaudit !==''}"   (click)="openModal(myModal,row,'QA','qa',row?.qa.name,row?.qa?.alert,row?.qa?.lastaudit)">
                        <div class="avatar-content">Q</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'QA','qa',row?.qa)">{{row?.qa}}</p> -->
                    </span>
                    <span placement="right" ngbTooltip="CR">
                      <div class="avatar mr-1 ml-0 badge badge-pill bg-light-success" [ngClass]="{'bg-light-danger':row?.crequest?.alert =='yes','avatar-border':row?.crequest?.name !=='' || row?.crequest?.lastaudit !==''}"   (click)="openModal(myModal,row,'CR','crequest',row?.crequest.name,row?.crequest?.alert,row?.crequest?.lastaudit)">
                        <div class="avatar-content">C</div>
                      </div>
                      <!-- <p (click)="openModal(myModal,row,'CR','crequest',row?.crequest)">{{row?.crequest}}</p> -->
                    </span>
                  </span>
                </ng-template>

              </ngx-datatable-column>

              <!-- <ngx-datatable-column name="FRS/DMS" prop="dmsfrs" [width]="150">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'FRS/DMS','dmsfrs',row?.dmsfrs)">{{row?.dmsfrs}}</p>
                </ng-template>
              </ngx-datatable-column> -->
              <!-- <ngx-datatable-column name="KPI" prop="kpi" [width]="100">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'KPI','kpi',row?.kpi)">{{row?.kpi}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Reports" prop="reports" [width]="150">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'Reports','reports',row?.reports)">{{row?.reports}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Work Dairy" prop="workdairy" [width]="120">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'Work Dairy','workdairy',row?.workdairy)">{{row?.workdairy}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="BitBucket" prop="bitbucket" [width]="120">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'BitBucket','bitbucket',row?.bitbucket)">{{row?.bitbucket}}</p>
                </ng-template>
              </ngx-datatable-column> -->
              <!-- <ngx-datatable-column name="Demo" prop="demo" [width]="140">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'Demo','demo',row?.demo)">{{row?.demo}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="QA" prop="qa" [width]="130">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'QA','qa',row?.qa)">{{row?.qa}}</p>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="CR" prop="crequest" [width]="150">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p (click)="openModal(myModal,row,'CR','crequest',row?.crequest)">{{row?.crequest}}</p>
                </ng-template>
              </ngx-datatable-column> -->
              <ngx-datatable-column name="Actions" [width]="80"
                *ngIf="user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                <ng-template let-row="row" ngx-datatable-cell-template> 
                  <i *ngIf="!row.sprints.name || !row.mom.name|| !row.crequest.name" class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/project/project-edit', row._id]"
                    ></i>
                    
                  <!-- <i class="ft-trash-2 cursor-pointer danger" (click)="ConfirmColor(row._id)"></i> -->
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->

<!----- Update Row Popup ----------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">{{jobs_data.name}}<span>'s</span> Update</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
        <div class="form-group">
					<label>Alert</label>
					<ng-select
											[items]="alert_list"
											bindLabel="name"
											color="is_activated"
											bindValue="id"
											placeholder="Select Alert"
											[(ngModel)]="alert_event"
											[ngModelOptions]="{ standalone: true }"
											(change)="selectAlert($event)" 
										>
										</ng-select>
				</div>
        <div class="form-group">
					<label>Last Audit</label>
					<input type="text" class="form-control" [(ngModel)]="lastAudit" [ngModelOptions]="{standalone: true}" >
				</div>
				<div class="form-group">
					<label>{{row_name}}</label>
					<input type="text" class="form-control" [(ngModel)]="row_value" [ngModelOptions]="{standalone: true}">
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="updateRow()">Submit</button>
		  </div>
	</ng-template>
</div>
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

